/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiWebhookTrigger } from './ApiWebhookTrigger';
import {
    ApiWebhookTriggerFromJSON,
    ApiWebhookTriggerFromJSONTyped,
    ApiWebhookTriggerToJSON,
    ApiWebhookTriggerToJSONTyped,
} from './ApiWebhookTrigger';
import type { ApiWebhookRequestStatus } from './ApiWebhookRequestStatus';
import {
    ApiWebhookRequestStatusFromJSON,
    ApiWebhookRequestStatusFromJSONTyped,
    ApiWebhookRequestStatusToJSON,
    ApiWebhookRequestStatusToJSONTyped,
} from './ApiWebhookRequestStatus';

/**
 * a Webhook request
 * @export
 * @interface ApiWebhookRequest
 */
export interface ApiWebhookRequest {
    /**
     * Unique webhook request ID
     * @type {number}
     * @memberof ApiWebhookRequest
     */
    id?: number;
    /**
     * Webhook ID
     * @type {number}
     * @memberof ApiWebhookRequest
     */
    webhookId: number;
    /**
     * 
     * @type {ApiWebhookTrigger}
     * @memberof ApiWebhookRequest
     */
    trigger: ApiWebhookTrigger;
    /**
     * Destination URL
     * @type {string}
     * @memberof ApiWebhookRequest
     */
    url: string;
    /**
     * 
     * @type {ApiWebhookRequestStatus}
     * @memberof ApiWebhookRequest
     */
    status: ApiWebhookRequestStatus;
    /**
     * Value of X-Salv-Token
     * @type {string}
     * @memberof ApiWebhookRequest
     */
    token?: string;
    /**
     * How long the HTTP request took in milliseconds (only set if status is not NEW)
     * @type {number}
     * @memberof ApiWebhookRequest
     */
    executionDuration?: number;
    /**
     * HTTP request body
     * @type {string}
     * @memberof ApiWebhookRequest
     */
    requestContent: string;
    /**
     * HTTP response body (only set if status is not NEW)
     * @type {string}
     * @memberof ApiWebhookRequest
     */
    responseContent?: string;
    /**
     * HTTP response status (only set if status is not NEW)
     * @type {string}
     * @memberof ApiWebhookRequest
     */
    responseStatus?: string;
    /**
     * If request has failed and is retried, this points to retry attempt
     * @type {number}
     * @memberof ApiWebhookRequest
     */
    retryId?: number;
    /**
     * When request is scheduled for automatic retry
     * @type {Date}
     * @memberof ApiWebhookRequest
     */
    retryTime?: Date;
    /**
     * When the webhook request event was created.
     * @type {Date}
     * @memberof ApiWebhookRequest
     */
    createdTime: Date;
}



/**
 * Check if a given object implements the ApiWebhookRequest interface.
 */
export function instanceOfApiWebhookRequest(value: object): value is ApiWebhookRequest {
    if (!('webhookId' in value) || value['webhookId'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('requestContent' in value) || value['requestContent'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function ApiWebhookRequestFromJSON(json: any): ApiWebhookRequest {
    return ApiWebhookRequestFromJSONTyped(json, false);
}

export function ApiWebhookRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhookRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'webhookId': json['webhookId'],
        'trigger': ApiWebhookTriggerFromJSON(json['trigger']),
        'url': json['url'],
        'status': ApiWebhookRequestStatusFromJSON(json['status']),
        'token': json['token'] == null ? undefined : json['token'],
        'executionDuration': json['executionDuration'] == null ? undefined : json['executionDuration'],
        'requestContent': json['requestContent'],
        'responseContent': json['responseContent'] == null ? undefined : json['responseContent'],
        'responseStatus': json['responseStatus'] == null ? undefined : json['responseStatus'],
        'retryId': json['retryId'] == null ? undefined : json['retryId'],
        'retryTime': json['retryTime'] == null ? undefined : (new Date(json['retryTime'])),
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function ApiWebhookRequestToJSON(json: any): ApiWebhookRequest {
    return ApiWebhookRequestToJSONTyped(json, false);
}

export function ApiWebhookRequestToJSONTyped(value?: ApiWebhookRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'webhookId': value['webhookId'],
        'trigger': ApiWebhookTriggerToJSON(value['trigger']),
        'url': value['url'],
        'status': ApiWebhookRequestStatusToJSON(value['status']),
        'token': value['token'],
        'executionDuration': value['executionDuration'],
        'requestContent': value['requestContent'],
        'responseContent': value['responseContent'],
        'responseStatus': value['responseStatus'],
        'retryId': value['retryId'],
        'retryTime': value['retryTime'] == null ? value['retryTime'] : value['retryTime'].toISOString(),
        'createdTime': value['createdTime'].toISOString(),
    };
}

